module.exports = __webpack_public_path__ + "static/media/fiska.9e39a08b.mp3";